<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/dn_logo_white.png" alt="logo">
    </div>
    <p class="title"></p>
    <p class="address_tel_fax">
      <span>地址：陕西省西安市高新区西高智能大厦1007室 | </span>
      <span>Tel：13572804477 </span>
      <!-- <span>Fax：8888-88888888</span> -->
    </p>
    <!-- <p class="email_wx">
      <span>邮箱：xianduonai@163.com | </span>
      <span>公司微信号：xianduonai</span>
    </p> -->
    <p class="copy">Copyright &copy; 2019 - {{yearNow()}} 西安多耐仪器仪表有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      yearNow: function () {
        let now = new Date();
        let yearnow = now.getFullYear().toString();
        return yearnow;
      }
    };
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  background: #234a8d;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 70px;
  height: 70px;
  margin: 25px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue